import * as ActionTypes from '../../actions/allActions'
import { normalizeContract } from '../../normalizers/Normalizers'

const allContractsInit = []
const allContracts = (state = allContractsInit, action) => {
	switch(action.type){
		case ActionTypes.FETCHCONTRACTS_SUCCESS:
			return action.data.data.map(contract => normalizeContract(contract))
		case ActionTypes.LOGOUT:
			return allContractsInit
		default:
			return state
	}
}

export default allContracts



// WEBPACK FOOTER //
// ./src/reducers/data/allContracts.js